import { render, staticRenderFns } from "./ProfilePreviewCard.vue?vue&type=template&id=277c6367&scoped=true"
import script from "./ProfilePreviewCard.vue?vue&type=script&lang=js"
export * from "./ProfilePreviewCard.vue?vue&type=script&lang=js"
import style0 from "./ProfilePreviewCard.vue?vue&type=style&index=0&id=277c6367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c6367",
  null
  
)

export default component.exports